<div class="p-4 md:p-6 max-w-7xl mx-auto">
  <!-- Header -->
  <h1 class="text-2xl font-bold text-gray-800 flex items-center mb-6">
    <mat-icon style="color: #1C593D; margin-right: 8px;">account_balance</mat-icon>
    Estatus Cajero Fiat (VES)
    <span *ngIf="dataSource" class="hidden md:inline text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full ml-2">
      {{ dataSource.filteredData.length }} cajeros
    </span>
  </h1>

  <!-- Card Filtros -->
  <div class="bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden mb-6">
    <div style="background: linear-gradient(135deg, #f0fdf4, #ecfdf5); padding: 16px 24px; border-bottom: 2px solid #bbf7d0;">
      <h2 style="margin: 0; font-size: 1rem; font-weight: 700; color: #1e5a3f; display: flex; align-items: center; gap: 8px;">
        <mat-icon style="font-size: 20px; width: 20px; height: 20px; color: #1C593D;">filter_list</mat-icon>
        Filtros
      </h2>
    </div>
    <div class="p-5">
      <div class="flex flex-col sm:flex-row items-end gap-4">
        <mat-form-field appearance="outline" class="modern-field flex-1">
          <mat-label>Filtrar por Banco</mat-label>
          <mat-select [(ngModel)]="selectedBanco" (selectionChange)="applyFilters()">
            <mat-option value="">Todos</mat-option>
            <mat-option *ngFor="let banco of bancos" [value]="banco">{{ banco }}</mat-option>
          </mat-select>
        </mat-form-field>

        <div class="flex gap-2 mb-1">
          <button type="button" (click)="clearFilters()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: white; color: #374151; border: 1px solid #d1d5db; border-radius: 10px; font-weight: 600; font-size: 0.85rem; cursor: pointer; transition: all 0.2s ease;"
            onmouseover="this.style.background='#f3f4f6'" onmouseout="this.style.background='white'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: #374151;">clear</mat-icon>
            Limpiar
          </button>
          <button type="button" (click)="loadData()"
            style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">refresh</mat-icon>
            Recargar
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Badge mobile -->
  <span *ngIf="dataSource" class="md:hidden inline-block text-sm font-semibold bg-green-100 text-green-800 px-3 py-1 rounded-full mb-4">
    {{ dataSource.filteredData.length }} cajeros
  </span>

  <!-- Tabla Desktop -->
  <div class="hidden lg:block bg-white rounded-2xl shadow-md border border-gray-100 overflow-hidden" *ngIf="dataSource">
    <div class="overflow-x-auto">
      <table mat-table [dataSource]="dataSource">

        <!-- Cajero -->
        <ng-container matColumnDef="cajero">
          <th mat-header-cell *matHeaderCellDef>Cajero</th>
          <td mat-cell *matCellDef="let row" class="clickable-cell" (click)="onCajeroClick(row)">
            <span class="text-xs font-semibold" style="color: #1C593D; cursor: pointer;">{{ row.cuenta.nombre }} {{ row.cuenta.apellidos }}</span>
          </td>
        </ng-container>

        <!-- Banco -->
        <ng-container matColumnDef="banco">
          <th mat-header-cell *matHeaderCellDef>Banco</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs">{{ row.cuenta.banco.nombre }}</span>
          </td>
        </ng-container>

        <!-- Moneda -->
        <ng-container matColumnDef="moneda">
          <th mat-header-cell *matHeaderCellDef>Moneda</th>
          <td mat-cell *matCellDef="let row">
            <span class="px-2 py-0.5 text-xs font-semibold rounded-full bg-blue-100 text-blue-700">{{ getCurrency(row.cuenta.banco.codigoPais) }}</span>
          </td>
        </ng-container>

        <!-- Balance en Sistema -->
        <ng-container matColumnDef="balanceSistema">
          <th mat-header-cell *matHeaderCellDef>Balance Sistema</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs font-bold" style="color: #1e5a3f;">{{ row.total | currency:'$' }}</span>
          </td>
        </ng-container>

        <!-- Balance Restante -->
        <ng-container matColumnDef="balance">
          <th mat-header-cell *matHeaderCellDef>Balance Restante</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs font-bold" [style.color]="(row.total - row.necesarioOb - row.necesarioMb) < 0 ? '#dc2626' : '#1e5a3f'">
              {{ (row.total - row.necesarioOb - row.necesarioMb) | currency:'$' }}
            </span>
          </td>
        </ng-container>

        <!-- Total -->
        <ng-container matColumnDef="total">
          <th mat-header-cell *matHeaderCellDef>Total</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs font-bold">{{ (row.necesarioOb + row.necesarioMb) | currency:'$' }}</span>
          </td>
        </ng-container>

        <!-- Necesario OB -->
        <ng-container matColumnDef="necesarioOB">
          <th mat-header-cell *matHeaderCellDef>Necesario OB</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs">{{ row.necesarioOb | currency:'$' }}</span>
          </td>
        </ng-container>

        <!-- Necesario MB -->
        <ng-container matColumnDef="necesarioMB">
          <th mat-header-cell *matHeaderCellDef>Necesario MB</th>
          <td mat-cell *matCellDef="let row">
            <span class="text-xs">{{ row.necesarioMb | currency:'$' }}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;" [ngClass]="getBlinkingClass(row)"></tr>
      </table>
    </div>
  </div>

  <!-- Cards Mobile -->
  <div class="lg:hidden space-y-3" *ngIf="dataSource">
    <div *ngFor="let row of dataSource.filteredData; let i = index"
      class="bg-white rounded-xl shadow-sm border overflow-hidden transition-all duration-200"
      [style.borderColor]="expandedCardId === i ? '#1C593D' : '#e5e7eb'"
      [ngClass]="getBlinkingClass(row)">

      <!-- Card header -->
      <div class="flex items-center justify-between p-3 cursor-pointer"
        (click)="toggleCard(i)"
        [style.background]="expandedCardId === i ? '#f0fdf4' : 'white'">
        <div class="flex items-center gap-2 flex-1 min-w-0">
          <span class="text-sm font-semibold truncate" style="color: #1C593D; cursor: pointer;" (click)="onCajeroClick(row); $event.stopPropagation()">
            {{ row.cuenta.nombre }} {{ row.cuenta.apellidos }}
          </span>
          <span class="px-2 py-0.5 text-xs font-semibold rounded-full bg-blue-100 text-blue-700 shrink-0">
            {{ getCurrency(row.cuenta.banco.codigoPais) }}
          </span>
        </div>
        <div class="flex items-center gap-2">
          <span class="text-sm font-bold shrink-0" style="color: #1e5a3f;">{{ row.total | currency:'$' }}</span>
          <mat-icon class="text-gray-400 shrink-0 transition-transform duration-200"
            [style.transform]="expandedCardId === i ? 'rotate(180deg)' : 'rotate(0)'">
            expand_more
          </mat-icon>
        </div>
      </div>

      <!-- Card body -->
      <div *ngIf="expandedCardId === i" class="px-3 pb-3 border-t border-gray-100">
        <div class="grid grid-cols-2 gap-2 mt-3 text-xs">
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Banco</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.cuenta.banco.nombre }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Balance Sistema</span>
            <p class="font-bold mt-0.5" style="color: #1e5a3f;">{{ row.total | currency:'$' }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Balance Restante</span>
            <p class="font-bold mt-0.5" [style.color]="(row.total - row.necesarioOb - row.necesarioMb) < 0 ? '#dc2626' : '#1e5a3f'">
              {{ (row.total - row.necesarioOb - row.necesarioMb) | currency:'$' }}
            </p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Total Comprometido</span>
            <p class="text-gray-700 font-bold mt-0.5">{{ (row.necesarioOb + row.necesarioMb) | currency:'$' }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Necesario OB</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.necesarioOb | currency:'$' }}</p>
          </div>
          <div>
            <span class="text-gray-400 font-semibold uppercase" style="font-size: 0.65rem;">Necesario MB</span>
            <p class="text-gray-700 font-medium mt-0.5">{{ row.necesarioMb | currency:'$' }}</p>
          </div>
        </div>
        <!-- Botón ver detalle -->
        <div class="mt-3 pt-3 border-t border-gray-100">
          <button type="button" (click)="onCajeroClick(row)" class="w-full"
            style="display: inline-flex; align-items: center; justify-content: center; gap: 6px; padding: 8px 20px; background: #1C593D; color: white; border: none; border-radius: 10px; font-weight: 700; font-size: 0.85rem; cursor: pointer; transition: background 0.2s ease;"
            onmouseover="this.style.background='#059669'" onmouseout="this.style.background='#1C593D'">
            <mat-icon style="font-size: 18px; width: 18px; height: 18px; color: white;">visibility</mat-icon>
            Ver Detalle
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
